export interface ColorSet {
  primary: string;
  secondary: string
  darker: string;
  name: string;
  secondaryText: string;
}

export const colors: Record<string, ColorSet> = {
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
    darker: '#0067ce',
    secondaryText: '#1e90ff',
    name: 'Azul'
  },
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
    darker: '#9a0007',
    secondaryText: '#ad2121',
    name: 'Vermelho'
  },
  yellow: {
    primary: '#6b5900',
    secondary: '#FFF9C4',
    secondaryText: '#6b5900',
    darker: '#F9A825',
    name: 'Amarelo'
  },
  green: {
    primary: '#2E7D32',
    secondary: '#E8F5E9',
    darker: '#1B5E20',
    secondaryText: '#2E7D32',
    name: 'Verde'
  },
  orange: {
    primary: '#BF360C',
    secondary: '#FFECB3',
    darker: '#E65100',
    secondaryText: '#BF360C',
    name: 'Laranja'
  },
  purple: {
    primary: '#673AB7',
    secondary: '#EDE7F6',
    darker: '#4527A0',
    secondaryText: '#673AB7',
    name: 'Roxo'
  },
  teal: {
    primary: '#00796B',
    secondary: '#E0F2F1',
    darker: '#004D40',
    secondaryText: '#00796B',
    name: 'Verde-água'
  },
  pink: {
    primary: '#D81B60',
    secondary: '#FCE4EC',
    darker: '#AD1457',
    secondaryText: '#D81B60',
    name: 'Rosa'
  },
  brown: {
    primary: '#795548',
    secondary: '#EFEBE9',
    darker: '#4E342E',
    secondaryText: '#795548',
    name: 'Marrom'
  },
  indigo: {
    primary: '#3949AB',
    secondary: '#E8EAF6',
    darker: '#283593',
    secondaryText: '#3949AB',
    name: 'Índigo'
  },
  cyan: {
    primary: '#00ACC1',
    secondary: '#E0F7FA',
    darker: '#006064',
    secondaryText: '#00ACC1',
    name: 'Ciano'
  }
};

export const colorArray: ColorSet[] = Object.values(colors);
